<script lang="ts" setup>
import { computed } from 'vue';
import SidePanelSection from '../SidePanel/SidePanelSection.vue';
import { useLocale } from '../../composables/useLocale';

type Props = {
  lastActiveAt: number | null;
  createdAt: number | null;
  updatedAt: number | null;
  isLoading: boolean;
};
const props = defineProps<Props>();

const { t } = useLocale();

const createdAtDate = computed(() => {
  if (!props.createdAt) return 'unknown';
  return new Date(props.createdAt).toLocaleDateString().replace(/(\/)/g, '-');
});
const updatedAtDate = computed(() => {
  if (!props.updatedAt) return 'unknown';
  return new Date(props.updatedAt).toLocaleDateString().replace(/(\/)/g, '-');
});

const lastActiveAtDate = computed(() => {
  if (!props.lastActiveAt) return 'unknown';
  return new Date(props.lastActiveAt).toLocaleDateString().replace(/(\/)/g, '-');
});
</script>

<template>
  <SidePanelSection :title="t('lcp.account_info')" :loading="isLoading">
    <v-row v-if="isLoading">
      <v-col>
        <v-skeleton-loader type="paragraph"></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row v-else class="flex-column ga-2" no-gutters>
      <v-col>
        <v-chip prepend-icon="mdi-account-multiple" style="margin: 0 !important">
          {{ t(`lcp.last_active`) }}: {{ lastActiveAtDate }}
        </v-chip>
      </v-col>
      <v-col>
        <v-chip prepend-icon="mdi-reload" style="margin: 0 !important">
          {{ t(`lcp.last_update`) }}: {{ updatedAtDate }}
        </v-chip>
      </v-col>
      <v-col>
        <v-chip prepend-icon="mdi-calendar-month" style="margin: 0 !important">
          {{ t(`lcp.created`) }}: {{ createdAtDate }}
        </v-chip>
      </v-col>
    </v-row>
  </SidePanelSection>
</template>
<style lang="scss" scoped></style>
